export const TOOLTIP_TEXT =
  'Enabling this feature allows advisors to choose which folders and files are shared with third-party document vault only users. These document vault only users are established in Orion Connect under Manage Users.';
